module.exports = __webpack_public_path__ + "static/media/snukFull.5f2d513c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snukFull.png
// module id = 1533
// module chunks = 0